/**
 * Removes the product variation post type from the object type selector
 *
 * Ticket https://jira.angrycreative.se/browse/HAS-613
 */
wp.hooks.addFilter( 'qalaElasticCore.filter.objectTypeSelector.allObjectTypes', 'hastaFilterProductVariations', allObjectTypes => {
	if ( allObjectTypes && Array.isArray( allObjectTypes ) ) {
		allObjectTypes = allObjectTypes.filter( objectType => objectType?.name && objectType.name !== 'product_variation' );
	}
	return allObjectTypes;
} );
